import VueRouter, { RouteConfig } from 'vue-router'
import { GlobalConfigRouteMetaEnum, VacationHomeworkType } from 'kuaidong-model'

const PlanList = () => import('../views/summer/PlanList.vue')
const CreatePlan = () => import('../views/summer/CreatePlan.vue')
const TemplateList = () => import('../views/summer/TemplateList.vue')
const SummerPlanPreview = () => import('../views/summer/TemplatePreview.vue')
const CompetionList = () => import('../views/summer/CompetionList.vue')
const ExamList = () => import('../views/summer/ExamList.vue')
const SummerEdit = () => import('../views/summer/Edit.vue')
const EditTemplateRoot = () => import('../views/summer/EditTemplateRoot.vue')
const TemplateEditGeneral = () => import('../views/summer/TemplateEditGeneral.vue')
const HomeworkDrillSelector = () => import('../views/homework/DrillSelector.vue')

const SummerVacationPlanPoster = () => import('../views/summer/Poster.vue')
const SummerVacationPlanPreview = () => import('../views/summer/Preview.vue')
const SummerVacationPlanDetails = () => import('../views/summer/Details.vue')

export const editRoute: RouteConfig = {
  path: '/summer-edit',
  name: 'summer_edit',
  component: SummerEdit,
  meta: {
    title: '作业计划',
  },
}

export const summerVacationPlanPosterRoute: RouteConfig = {
  path: '/summer-vacation-plan-poster',
  name: 'summer_vacation_plan_poster',
  component: SummerVacationPlanPoster,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '作业计划',
  },
}

export const summerVacationPlanPreviewRoute: RouteConfig = {
  path: '/summer-vacation-plan-preview',
  name: 'summer_vacation_plan_preview',
  component: SummerVacationPlanPreview,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '计划预览',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}

export const summerVacationPlanDetailsRoute: RouteConfig = {
  path: '/summer-vacation-plan-details',
  component: SummerVacationPlanDetails,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '计划详情',
  },
  children: [
    {
      path: 'stat',
      name: 'summer_vacation_plan_details_stat',
      component: () => import('@/views/summer/DetailsStat.vue'),
    },
    {
      path: 'info',
      name: 'summer_vacation_plan_details_info',
      component: () => import('@/views/summer/DetailsInfo.vue'),
      meta: {
        [GlobalConfigRouteMetaEnum.All]: true,
      },
    },
  ],
}

export const summerPlanRoute: RouteConfig = {
  path: '/summer-plan',
  name: 'summer_plan',
  component: PlanList,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '计划列表',
  },
}

export const summerCreatePlanRoute: RouteConfig = {
  path: '/create-summer-plan',
  name: 'crate_summer_plan',
  component: CreatePlan,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '作业计划',
  },
}

export const templateListRoute: RouteConfig = {
  path: '/summer/template-list',
  name: 'summer_tempalte_list',
  component: TemplateList,
  meta: {
    title: '作业模板',
  },
  props: (route) => ({ index: route.query.i }),
}

export const templateCustomRoute: RouteConfig = {
  path: '/summer/template-edit',
  component: EditTemplateRoot,
  redirect: '/summer/template-edit/item',
  meta: {
    title: '作业内容',
  },
  props: (route) => ({ index: route.query.i }),
  children: [
    {
      path: 'item',
      name: 'summer_tempalte_edit_item',
      component: TemplateEditGeneral,
      meta: {
        title: '作业内容',
        [GlobalConfigRouteMetaEnum.All]: true,
      },
      props: (route) => ({
        totalSteps: 1,
        currentStep: 1,
        index: route.query.index,
        i: route.query.i,
        form: route.query.form ? JSON.parse(`${route.query.form}`) : 'null',
      }),
    },
    {
      path: 'drills',
      name: 'summer_plan_edit_drills',
      component: HomeworkDrillSelector,
      meta: {
        title: '选择项目',
        [GlobalConfigRouteMetaEnum.All]: true,
      },
      props: (route) => ({
        ...route.query,
        ...route.params,
        ids: route.query.ids || [],
      }),
    },
  ],
}

export const templatePreviewRoute: RouteConfig = {
  path: '/summer/template-preview',
  name: 'summer_plan_preview',
  component: SummerPlanPreview,
  meta: {
    title: '作业预览',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
  props: (route) => ({
    template: route.query.template ? JSON.parse(route.query.template as string) : null,
    index: route.query.index,
    i: route.query.i,
  }),
}

export const competionListRoute: RouteConfig = {
  path: '/summer-competion-list',
  name: 'summer_competion_list',
  component: CompetionList,
  meta: {
    title: '比赛列表选项',
  },
  props: (route) => ({ index: route.query.i }),
}

export const examListRoute: RouteConfig = {
  path: '/summer-exam-list',
  name: 'summer_exam_list',
  component: ExamList,
  meta: {
    title: '体测列表选项',
  },
  props: (route) => ({ index: route.query.i }),
}

export default [
  editRoute,
  summerVacationPlanPosterRoute,
  summerVacationPlanPreviewRoute,
  summerVacationPlanDetailsRoute,
  summerPlanRoute,
  summerCreatePlanRoute,
  templateListRoute,
  templateCustomRoute,
  templatePreviewRoute,
  competionListRoute,
  examListRoute,
]

export function navigateToSummerEdit(router: VueRouter) {
  router.push({ name: editRoute.name })
}

export function navigateToSummerPlanList(router: VueRouter, hwType = VacationHomeworkType.WinterVacation2021) {
  router.push({ name: summerPlanRoute.name, query: { hwType } })
}

export function navigateToSummerCreatePlan(router: VueRouter, hwType = VacationHomeworkType.WinterVacation2021) {
  router.push({ name: summerCreatePlanRoute.name, query: { hwType } })
}

export function navigateToTemplateCustomRoute(router: VueRouter) {
  router.push({ name: templateCustomRoute.name })
}

export function navigateToTemplatePreviewRoute(router: VueRouter) {
  router.push({ name: templatePreviewRoute.name })
}

export function navigateToSummerVacationPlanPoster(router: VueRouter, id: string) {
  router.push({ name: summerVacationPlanPosterRoute.name, query: { id } })
}

export function navigateToSummerVacationPlanStatDetails(router: VueRouter, id: string) {
  router.push({ name: summerVacationPlanDetailsRoute.children![0].name, query: { id } })
}

export function navigateToSummerVacationPlanDetails(router: VueRouter, id: string) {
  router.push({ name: summerVacationPlanDetailsRoute.children![1].name, query: { id } })
}
